import React from "react";
import SectionTitle from "../SectionTitle";
import cristelloLogo from "../../../assets/img/critstello-logo.png";
import epicoriumLogo from "../../../assets/img/epicoriums.png";
const Count = () => {
  return (
    <>
      <section id="counts" className="counts">
        <div className="container" data-aos="fade-up">
          <SectionTitle title={"Please visit Our Partners"} />
          <div className="row ">
            <div className="col-lg-6 col-md-6 d-md-flex align-items-md-stretch">
              <div
                className="count-box"
                style={{
                  display: "flex",
                  justifyContent: "center",

                  margin: "10px 0px",
                }}
              >
                <a
                  className="partnerLogoCUTISKART"
                  href="https://www.cutiskart.com/"
                  target="_blank"
                >
                  <div>
                    <img
                      style={{ height: "100%", width: "auto" }}
                      src="/assets/img/home/CUTISKART-Logo.png"
                      alt="CUTISKART Logo"
                    />
                    <br />
                    <small>Online Pharmacy</small>
                  </div>
                </a>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 d-md-flex align-items-md-stretch">
              <div
                className="count-box"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "10px 0px",
                }}
              >
                <a
                  className="partnerLogoOffSpring"
                  href="https://offspringmaternity.in/"
                  target="_blank"
                >
                  <div>
                    <img
                      style={{ height: "65px", width: "auto" }}
                      src="/assets/img/home/offspring 1.png"
                      alt="Offspring Maternity & Child care Logo"
                    />
                    <br />
                    <small>Gynecology and Maternity centre</small>
                  </div>
                </a>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 d-md-flex align-items-md-stretch">
              <div
                className="count-box"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "10px 0px",
                }}
              >
                <a
                  className="partnerLogoOffSpring"
                  href="https://epicorium.com/"
                  target="_blank"
                >
                  <div>
                    <img
                      style={{
                        width: "auto",
                        marginTop: "-20px",
                      }}
                      src={epicoriumLogo}
                      alt="Offspring Maternity & Child care Logo"
                    />

                    <br />
                  </div>
                </a>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 d-md-flex align-items-md-stretch">
              <div
                className="count-box"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "10px 0px",
                }}
              >
                <a
                  className="partnerLogoOffSpring"
                  href="https://www.cristello.in/"
                  target="_blank"
                >
                  <div>
                    <img
                      style={{
                        height: "50px",
                        width: "auto",
                        marginTop: "-20px",
                      }}
                      src={cristelloLogo}
                      alt=" Cutis x Cristello Logo"
                    />

                    <br />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="home-page-seo-text">
          <h2>Best Dermatology Hospital in Bangalore</h2>
          <p>
            Cutis is a center of excellence for overall skin, hair, and nail
            care treatment. We are the most trusted
            <a href="https://cutis.org.in/chief-dermatologist"> dermatology </a>
            clinic when it comes to skin, hair, and nail care. Our experts offer
            professional care for Acne, Acne Scar, Anti-aging, Laser Hair
            Reduction, Hair Transplantation, and other services. Cutis is a
            leading dermatology hospital in Bangalore that offers high-quality
            care and advanced treatments.
          </p>
        </div>
      </section>
    </>
  );
};

export default Count;
